import { Component, Input, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Subject } from "rxjs";
import { warningPopResponse } from "src/app/shared/app.constant";

@Component({
    selector: 'app-kc-warning-popup',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './kc-warning-popup.component.html',
    styleUrls: ['./kc-warning-popup.component.scss']
})

export class KcWarningPopupComponent implements OnInit {
    event = new Subject<number>();
    popupRes = warningPopResponse;
    mainContent: any = '';
    subContent: any = 'Are you sure you want to proceed?';
    isYesReq: boolean = true;
    isNoReq: boolean = true;
    isSaveAndCloseReq: boolean = false;
    isSubContent: boolean = true;
    isConfirm: boolean = false;
    isUpdateAll: boolean = false;
    isCancel: boolean = false;
    // Commenting code as requested by BA - donoor for  Ticket - 7105, Developer - Yash S
    // isInvoice: boolean = false;
    isOkReq: boolean = false;
    isWarning: boolean = true;

    @Input() yesText: string = 'Yes';
    @Input() noText: string = 'No';
    @Input() okText: string = 'Ok';

    constructor() { }

    ngOnInit(): void { }
}